'use client';

import type { FC } from 'react';
import { buttonVariants } from '@paypoteam/ui-components';
import Link from 'next/link';

import { cn } from '@/lib/utils';

import { ContentText } from '@/components/molecules/ContentText';
import type {
    CtaProps,
    InlineTilesSectionProps,
} from '@/components/sections/InlineTilesSection/InlineTileSection.types';
import ItemsContainerSection from '@/components/sections/ItemsContainerSection';

const InlineTilesSection: FC<InlineTilesSectionProps> = ({
    cta,
    additionalText,
    items,
    ...props
}) => {
    const {
        size,
        variant,
        className: linkClassName,
        'data-test-id': linkDataTestId,
        ...linkProps
    } = cta || ({} as CtaProps);

    const footer = (
        <>
            {!!additionalText && (
                <ContentText
                    textConfig={additionalText}
                    className="mt-10"
                />
            )}

            {!!linkProps.href && (
                <Link
                    className={cn(
                        buttonVariants({ size, variant }),
                        'mt-6 w-fit md:mt-8 lg:!mt-10',
                        linkClassName,
                    )}
                    data-test-id={linkDataTestId}
                    {...linkProps}
                />
            )}
        </>
    );

    return (
        <ItemsContainerSection
            footerNode={footer}
            containerClassName="w-full flex flex-col items-center"
            items={items}
            {...props}
        />
    );
};

export default InlineTilesSection;
